import { render, staticRenderFns } from "./StoreSwitcher.vue?vue&type=template&id=31ff97d2&scoped=true"
import script from "./StoreSwitcher.vue?vue&type=script&lang=ts"
export * from "./StoreSwitcher.vue?vue&type=script&lang=ts"
import style0 from "./StoreSwitcher.vue?vue&type=style&index=0&id=31ff97d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ff97d2",
  null
  
)

export default component.exports